import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Modal from '../../../Shared/Modal';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  modal: {
    width: '100%',
    maxWidth: 1000,
    padding: '0 40px 40px 40px',
  },
  modalContainer: {
    width: '100%',
    maxWidth: 1000,
  },
  modalSecondTitle: {
    paddingBottom: theme.spacing(2),
    padding: theme.spacing(0, 16),
    [theme.breakpoints.down(1000)]: {
      padding: theme.spacing(0),
    },
  },
  italic: {
    fontStyle: 'italic',
  },
  bold: {
    fontWeight: 600,
  },
  blueText: {
    color: '#172b4d',
    fontSize: '0.875rem',
    lineHeight: 1.43,
    marginTop: 20,
  },
  blackText: {
    fontSize: '0.875rem',
    lineHeight: 1.43,
    marginTop: 20,
  },
  text: {
    fontSize: '0.875rem',
    lineHeight: 1.43,
    marginTop: 20,
  },
  row: {
    display: 'flex',
    alignItems: 'baseline',
  },
  listItem: {
    margin: 5,
  },
  list: {
    margin: 0,
  },
  decimalList: {
    listStyleType: 'decimal',
  },
}));

const PediatricAllergyBaselineAssessmentReport = ({
                                                    showHelpPopup,
                                                    setShowHelpPopup,
                                                  }) => {
  const classes = useStyles();
  const { en: { pediatricAllergyBaselineAssessmentReport } } = useSelector((state) => state.i18n);

  return (
    <Modal
      open={showHelpPopup}
      handleClose={() => {
        setShowHelpPopup(false);
      }}
      classes={{ paper: classes.modal, container: classes.modalContainer }}
      title={pediatricAllergyBaselineAssessmentReport.title}
      secondTitleStyle={classes.modalSecondTitle}
    >
      <div className={cx(classes.blackText, classes.bold)}>
        {pediatricAllergyBaselineAssessmentReport.firstPart}
      </div>
      <div className={cx(classes.blackText)}>
        {pediatricAllergyBaselineAssessmentReport.requirementsFirst}
      </div>
      <div className={cx(classes.blackText)}>
        {pediatricAllergyBaselineAssessmentReport.requirementsSecond}
      </div>
      <div className={cx(classes.blackText, classes.italic)}>
        {pediatricAllergyBaselineAssessmentReport.requirementsThird}
      </div>
      <div className={cx(classes.blackText, classes.italic)}>
        {pediatricAllergyBaselineAssessmentReport.requirementsForth}
      </div>
      <div className={cx(classes.blueText, classes.bold)}>
        {pediatricAllergyBaselineAssessmentReport.QHSLabAllergyAssessmentTitle}
      </div>
      <div>
        {pediatricAllergyBaselineAssessmentReport.QHSLabAllergyAssessmentText}
      </div>

      <div className={cx(classes.blueText, classes.bold)}>
        {pediatricAllergyBaselineAssessmentReport.respiratoryAllergyPredictionTestTitle}
      </div>
      <div>
        {pediatricAllergyBaselineAssessmentReport.respiratoryAllergyPredictionTestText}
      </div>
      <div className={cx(classes.blueText, classes.bold)}>
        {pediatricAllergyBaselineAssessmentReport.generalAllergyHistoryTitle}
      </div>
      <div>
        {pediatricAllergyBaselineAssessmentReport.generalAllergyHistoryText}
      </div>
      <div className={cx(classes.blueText, classes.bold)}>
        {pediatricAllergyBaselineAssessmentReport.patientReportedAllergySymptomsTitle}
      </div>
      <div>
        {pediatricAllergyBaselineAssessmentReport.patientReportedAllergySymptomsText}
      </div>
      <div className={cx(classes.blueText, classes.bold)}>
        {pediatricAllergyBaselineAssessmentReport.sinoNasalOutcomeTestTitle}
      </div>
      <div>
        {pediatricAllergyBaselineAssessmentReport.sinoNasalOutcomeTestText1}
      </div>
      <div className={cx(classes.text)}>
        {pediatricAllergyBaselineAssessmentReport.sinoNasalOutcomeTestText2}
      </div>
      <ul className={classes.list}>
        <li>
          <div className={classes.row}>
            <p className={cx(classes.blueText, classes.bold, classes.listItem)}>
              {pediatricAllergyBaselineAssessmentReport.sinoNasalOutcomeTestMildTitle}:
            </p>
            <p className={cx(classes.listItem)}>
              {pediatricAllergyBaselineAssessmentReport.sinoNasalOutcomeTestMildText}
            </p>
          </div>
        </li>
        <li>
          <div className={classes.row}>
            <p className={cx(classes.blueText, classes.bold, classes.listItem)}>
              {pediatricAllergyBaselineAssessmentReport.sinoNasalOutcomeTestModerateTitle}:
            </p>
            <p className={cx(classes.listItem)}>
              {pediatricAllergyBaselineAssessmentReport.sinoNasalOutcomeTestModerateText}
            </p>
          </div>
        </li>
        <li>
          <div className={classes.row}>
            <p className={cx(classes.blueText, classes.bold, classes.listItem)}>
              {pediatricAllergyBaselineAssessmentReport.sinoNasalOutcomeTestSevereTitle}:
            </p>
            <p className={cx(classes.listItem)}>
              {pediatricAllergyBaselineAssessmentReport.sinoNasalOutcomeTestSevereText}
            </p>
          </div>
        </li>
      </ul>
      <div className={cx(classes.text)}>
        {pediatricAllergyBaselineAssessmentReport.sinoNasalOutcomeTestText3}
      </div>

      <div className={cx(classes.blueText, classes.bold)}>
        {pediatricAllergyBaselineAssessmentReport.asthmaControlTestTitle}
      </div>
      <div>
        {pediatricAllergyBaselineAssessmentReport.asthmaControlTestText}
      </div>
      <div className={cx(classes.blueText, classes.bold)}>
        {pediatricAllergyBaselineAssessmentReport.allergyMedicationUseTitle}
      </div>
      <div className={cx(classes.blueText, classes.bold)}>
        {pediatricAllergyBaselineAssessmentReport.allergyMedicationUseText}
      </div>
      <div className={cx(classes.text, classes.bold)}>
        {pediatricAllergyBaselineAssessmentReport.referencesTitle}
      </div>
      <ul className={cx(classes.decimalList, classes.list)}>
        <li>{pediatricAllergyBaselineAssessmentReport.referencesFirst}</li>
        <li>
          {pediatricAllergyBaselineAssessmentReport.referencesSecond}
        </li>
        <li>{pediatricAllergyBaselineAssessmentReport.referencesThird}</li>
        <li>
          {pediatricAllergyBaselineAssessmentReport.referencesFourth}
        </li>
        <li>{pediatricAllergyBaselineAssessmentReport.referencesFifth}</li>
        <li>{pediatricAllergyBaselineAssessmentReport.referencesSixth}</li>
      </ul>
    </Modal>
  );
};

PediatricAllergyBaselineAssessmentReport.propTypes = {
  showHelpPopup: PropTypes.bool.isRequired,
  setShowHelpPopup: PropTypes.func.isRequired,
};

export default PediatricAllergyBaselineAssessmentReport;
